React = require 'react'
Auth = require 'db/auth'
Controller = require 'controller'
Storage = require 'lib/storage'
t = require('views/internal/recup-with-helpers')()
{ FeatureFeedbackLink } = require './presentational/feature-feedback-link'
{ StickyBoxWaitForMount } = require 'common/components/sticky-box-wait-for-mount'
trackUe = require 'debug/trackUe'
HomeLeftSidebarContainer = require 'views/home/home-left-sidebar-container'
HomeMainContentContainer = require 'views/home/home-main-content-container'
HomeRightSidebarContainer = require 'views/home/home-right-sidebar-container'

module.exports = class HomeContainer extends React.Component
  displayName: 'HomeContainer'

  constructor: (props) ->
    super props

    @dismissTeamBoardsFeedbackLink = @dismissTeamBoardsFeedbackLink.bind(@)
    @dismissTeamCardsFeedbackLink = @dismissTeamCardsFeedbackLink.bind(@)

  dismissFeedbackLink: (type) ->
    { modelCache, orgname } = @props
    orgId = modelCache.findOne('Organization', 'name', orgname)?.id

    if type == 'boards'
      dirObj = 'team boards feedback link'
      indObj = 'on team boards tab'
      method = 'by clicking dismiss in team boards feedback link'
      Auth.me().dismiss("homeTeamBoardsFeedbackLink")
    else
      dirObj = 'team cards feedback link'
      indObj = 'on team cards tab'
      method = 'by clicking dismiss in team cards feedback link'
      Auth.me().dismiss("homeTeamCardsFeedbackLink")

    trackUe('home', 'dismisses', dirObj, '', indObj, method, { teamId: orgId })

  dismissTeamBoardsFeedbackLink: ->
    @dismissFeedbackLink 'boards'

  dismissTeamCardsFeedbackLink: ->
    @dismissFeedbackLink 'cards'

  render: t.renderable ->
    { modelCache, model, orgname, allBoards, orgBoards, setFocusedCard, orgCards } = @props

    t.div '.home-container', =>
      t.div '.home-sticky-container', =>
        t.tag StickyBoxWaitForMount, =>
          t.tag HomeLeftSidebarContainer, {
            modelCache
            model
            orgname
            allBoards
            orgBoards
            orgCards
          }
        if allBoards
          t.div '.all-boards', ->
            t.tag StickyBoxWaitForMount, =>
              t.div '.content-all-boards', =>
                allBoards()
        else if orgBoards
          t.div '.all-boards', =>
            t.tag StickyBoxWaitForMount, =>
              t.div '.content-all-boards', =>
                if !Auth.me().isDismissed('homeTeamBoardsFeedbackLink')
                  t.tag FeatureFeedbackLink, {
                    feedbackLinkUrl: "https://trello.typeform.com/to/yCCWjK?memberid=#{Auth.me().id}"
                    onDismissIconClick: @dismissTeamBoardsFeedbackLink
                  }
                orgBoards()
        else if orgCards
          t.div '.all-cards', =>
            if !Auth.me().isDismissed('homeTeamCardsFeedbackLink')
                t.tag FeatureFeedbackLink, {
                  feedbackLinkTranslationKey: 'feature-my-cards-feedback-info'
                  feedbackLinkUrl: "https://trello.typeform.com/to/eSTqsi?memberid=#{Auth.me().id}"
                  onDismissIconClick: @dismissTeamCardsFeedbackLink
                }
            orgCards()
        else
          t.tag HomeMainContentContainer, {
            modelCache
            orgname
            setFocusedCard
          }
          t.tag StickyBoxWaitForMount, =>
            t.tag HomeRightSidebarContainer, {
              modelCache
              model
              orgname
            }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-container.coffee